import { Button, Col, message, Row, Typography } from 'antd'
import React, { useEffect } from 'react'
import { handleMyTax } from '../../../helper'
import './SelfEmployedStatus.css'
import { useMutateConfirmMyTaxStatus } from '../../../api/react-query/partners'
import { useStores } from '../../../Store/Store'
import PersistentCooldownButton from './PersistentCooldownButton'
import { storageKeys } from '../../../Constants'
import KuperLink from '../../../components/UI/KuperLink'

const { Title } = Typography

export default function StatusConfirmation ({ loading, handleUpdateScreen }) {
  const { partnerProfile } = useStores()

  const {
    data: dataTaxStatus,
    mutate: confirmTaxStatus,
    isSuccess: isSuccessTaxStatus,
    isError: isErrorTaxStatus,
    isLoading: isLoadingTaxStatus
  } = useMutateConfirmMyTaxStatus()

  // const {
  //   data: dataTaxBind,
  //   mutate: confirmTaxBind,
  //   isSuccess: isSuccessTaxBind,
  //   isError: isErrorTaxBind,
  //   isLoading: isLoadingTaxBind
  // } = useMutateConfirmMyTaxBind()

  useEffect(() => {
    if (isSuccessTaxStatus && dataTaxStatus?.isSuccess) {
      message.success('Запрос отправлен')
      // if (
      //   dataTaxStatus?.partner?.profile?.smz?.requiredAction === profile?.smz?.requiredAction &&
      //   dataTaxStatus?.partner?.profile?.smz?.errorCode === profile?.smz?.errorCode
      // ) {
      //   showMessageError({
      //     requiredAction: dataTaxStatus?.partner?.profile?.smz?.requiredAction,
      //     errorCode: dataTaxStatus?.partner?.profile?.smz?.errorCode
      //   })
      // }
      partnerProfile.setPartnerProfile(dataTaxStatus?.partner)
      handleUpdateScreen && handleUpdateScreen(dataTaxStatus?.partner?.profile)
    } else if (isErrorTaxStatus || dataTaxStatus?.errorMessage) {
      message.error(dataTaxStatus?.errorMessage || 'Ошибка запроса проверки статуса')
    }
  }, [isSuccessTaxStatus, isErrorTaxStatus, dataTaxStatus])

  // const {
  //   mutate: updatePartnerProfile,
  //   data: dataUpdatePartnerProfile,
  //   isSuccess: isSuccessUpdatePartnerProfile,
  //   isError: isErrorUpdatePartnerProfile,
  //   isLoading: isLoadingUpdatePartnerProfile
  // } = useMutatePartnerProfile()

  // useEffect(() => {
  //   if (isSuccessUpdatePartnerProfile && dataUpdatePartnerProfile?.isSuccess) {
  //     message.success('Запрос отправлен')
  //     partnerProfile.setPartnerProfile({
  //       ...dataUpdatePartnerProfile,
  //       ...(partnerProfile?.id ? { id: partnerProfile?.id } : {})
  //     })
  //   } else if (isErrorUpdatePartnerProfile || dataUpdatePartnerProfile?.errorMessage) {
  //     message.error(dataUpdatePartnerProfile?.errorMessage || 'Ошибка запроса проверки статуса')
  //   }
  // }, [dataUpdatePartnerProfile, isSuccessUpdatePartnerProfile, isErrorUpdatePartnerProfile])

  const handleClick = () => {
    confirmTaxStatus({})
  }

  return (
    <Row justify='space-between' className='selfEmployedStatus '>
      <Col span={24} className='info-block'>
        <Row>
          <Col span={24}>
            <Title level={3}>Остался последний шаг</Title>

            <p>
              Получите статус самозанятого
            </p>
            <p>
              С ним вы сможете выполнять заказы и оказывать услуги
            </p>
            <p>
              <ul>
                <li>Перейдите в «Мой налог» — на сайт или в приложение</li>
                <li>Зарегистрируйтесь, используя любой удобный метод. Важно оформлять самозанятость на этот же номер телефона</li>
                <li>Дождитесь сообщения о регистрации. Обычно это занимает не более 5 минут</li>
                <li>Вернитесь на этот экран и нажмите «Готово»</li>
              </ul>
            </p>
            <p>
              Если у вас уже есть статус самозанятого:
            </p>

            <p>
              <ol style={{ paddingLeft: 22 }}>
                <li>либо измените номер в приложении "Мой налог", вернитесь на этот экран и нажмите "Готово"</li>
                <li>либо заполните форму <KuperLink /> и укажите номер телефона из вашего аккаунта в «Мой налог». Затем ждите звонка оператора для завершения регистрации</li>
              </ol>
            </p>

            <p>
              Если возникнут сложности, звоните: 8 800 250 54 50
            </p>

            {/* <p>
              По вашему номеру телефона нет статуса Самозанятого, перейдите в Мой налог и получите статус Самозантого, либо оформитесь в найме Купера под корректным номером телефона, либо смените номер телефона в ФНС на тот, с которым вы прошли найм в Купер
            </p> */}
            {/* <p>Ваши данные в анкете и на сайте ФНС не совпадают. Пожалуйста, исправьте ФИО на сайте ФНС</p>
            <p>Если возникнут сложности, звоните: 8 800 250 54 50</p> */}
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <img src='/img/pencil.png' className='pencil' />
          </Col>
        </Row>
      </Col>

      <Col span={24} className='btn-block'>
        <Button
          className='btn-my-tax'
          size='large'
          block
          onClick={handleMyTax}
        >
          <img src='/img/fns.png' className='mr-3' />Перейти в «Мой налог»
        </Button>
        {/* <Button
          block
          ghost
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20'
          onClick={handleClick}
          loading={loading || isLoadingTaxStatus}
        >
          Готово
        </Button> */}
        <PersistentCooldownButton
          text='Готово'
          storageKey={storageKeys.cooldownBtnStatusConfirmation}
          size='large'
          type='primary'
          className='margin-top-20 margin-bottom-20 ant-btn-background-ghost'
          loading={loading || isLoadingTaxStatus}
          onClick={handleClick}
        />
      </Col>
    </Row>
  )
}
